import { useMyParcelsContext } from '@/modules/pmt/context';
import { useEmailSyncPopup } from '@/modules/pmt/hooks/useEmailSyncPopup.hook';
import { gtmViewLoginCta } from '@/utils';
import { useEffect } from 'react';
import { useAnonymousESBannerCopy } from '../../hooks';
import {
  EmailSyncCTAContent,
  EmailSyncCTAWrapper,
  JoinUsButton,
  MainGraphic,
  MainText,
  NewLabel,
} from './AnonymousESBanner.styles';

export const AnonymousESBanner: React.FC = () => {
  const { notificationTranslation } = useMyParcelsContext();
  const { identifier } = notificationTranslation;
  const { newLabel, description, cta } = useAnonymousESBannerCopy();

  const { openEmailSyncPopup } = useEmailSyncPopup();

  useEffect(() => {
    gtmViewLoginCta(identifier);
  }, [identifier]);

  return (
    <EmailSyncCTAWrapper>
      <MainGraphic src='/images/es-cta-graphic.png' alt='Email Sync CTA' />
      <NewLabel>{newLabel}</NewLabel>
      <EmailSyncCTAContent>
        <MainText>{description}</MainText>
        <JoinUsButton onClick={openEmailSyncPopup}>{cta}</JoinUsButton>
      </EmailSyncCTAContent>
    </EmailSyncCTAWrapper>
  );
};
